const ORIGINAL_ENHANCED_LOGGING_PREFERENCE = 'ORIGINAL_ENHANCED_LOGGING_PREFERENCE';

export function resetEnhancedLoggingPreferenceToOriginal(setEnhancedLoggingEnabled: (enabled: boolean) => void) {
  const originalEnhancedLoggingPreference = localStorage.getItem(ORIGINAL_ENHANCED_LOGGING_PREFERENCE);

  // If ORIGINAL_ENHANCED_LOGGING_PREFERENCE is set explicitly, we reset enhanced logging preference and remove the item
  if (originalEnhancedLoggingPreference !== null) {
    setEnhancedLoggingEnabled(JSON.parse(originalEnhancedLoggingPreference) as boolean);
    localStorage.removeItem(ORIGINAL_ENHANCED_LOGGING_PREFERENCE);
  }
}

export function storeOriginalEnhancedLoggingPreference(enhancedLoggingEnabled: boolean) {
  const originalEnhancedLoggingPreference = localStorage.getItem(ORIGINAL_ENHANCED_LOGGING_PREFERENCE);

  // If ORIGINAL_ENHANCED_LOGGING_PREFERENCE is not set already, we store the current enhanced logging preference
  if (originalEnhancedLoggingPreference === null) {
    localStorage.setItem(ORIGINAL_ENHANCED_LOGGING_PREFERENCE, `${enhancedLoggingEnabled}`);
  }
}
